import _ from "lodash";
import React, { useState } from "react";

import { Button, Icon, Input } from "../../../components";
import { useHighlightContext } from "../HighlightContext/HighlightContext";
import { useIntlTranslate } from "../../../hooks";

import "./HelpSearch.scss";

export const HelpSearch = () => {
  const translate = useIntlTranslate();
  const [isSearchApplied, setSearchApplied] = useState(false);
  const [inputValue, handleInputValueChange] = useState("");

  const { amountHighlightedItems, onDoSearch, onGoToNext, onGoToPrevious } =
    useHighlightContext();
  const hint =
    isSearchApplied &&
    translate("help_page_search_hint", { amount: amountHighlightedItems });

  const emitValue = _.debounce((searchValue) => {
    const isInputLongEnough = searchValue.length > 2;

    setSearchApplied(isInputLongEnough);
    onDoSearch(isInputLongEnough ? searchValue : "");
  }, 300);

  const handleInputChange = (searchValue) => {
    emitValue(searchValue);
    handleInputValueChange(searchValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onGoToNext();
  };

  return (
    <form
      className="help-search"
      onSubmit={handleSubmit}
      role="search"
      aria-label={translate("aria_help_form")}
    >
      <Input
        type="text"
        icon="fa-solid fa-search"
        className="help-search__input"
        aria-label={translate("aria_help_search_input")}
        aria-describedby={"help-search__input-status"}
        value={inputValue}
        onChange={(e) => handleInputChange(e.target.value)}
        onClear={() => handleInputChange("")}
        hint={hint}
      />
      <Button
        className="help-search__nav-button"
        size="large"
        color="secondary"
        onClick={onGoToNext}
        aria-label={translate("aria_help_search_btn_next")}
      >
        <Icon icon="fa-regular fa-angle-down" />
      </Button>
      <Button
        className="help-search__nav-button"
        size="large"
        color="secondary"
        onClick={onGoToPrevious}
        aria-label={translate("aria_help_search_btn_prev")}
      >
        <Icon icon="fa-regular fa-angle-up" />
      </Button>
      <span className="sr-only" id="help-search__input-status" role="status">
        {hint}
      </span>
    </form>
  );
};
